import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import './Button.css';
import './IconButton.css';

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'disabled'> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  icon: ReactNode;
  /** Required — an icon-only control has no accessible name without it. */
  label: string;
  disabled?: boolean;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { variant = 'ghost', size = 'md', icon, label, disabled, className, ...rest },
  ref
) {
  return (
    <button
      ref={ref}
      type={rest.type ?? 'button'}
      className={['dpr-button', `dpr-button--${variant}`, `dpr-icon-button`, `dpr-icon-button--${size}`, className]
        .filter(Boolean)
        .join(' ')}
      disabled={disabled}
      aria-label={label}
      title={label}
      {...rest}
    >
      <span aria-hidden="true" className="dpr-icon-button__icon">
        {icon}
      </span>
    </button>
  );
});
